import * as React from 'react';
import { useSelector } from 'react-redux';
import { plural } from '@cian/utils';
import { selectPagination } from '../../selectors/pagination';
import { Responsive, UIHeading4, UIText2 } from '@cian/ui-kit';

export const CounterContainer = () => {
  const { total } = useSelector(selectPagination);

  const text = React.useMemo(() => {
    const projectWord = plural(total, ['проект', 'проекта', 'проектов']);

    return `${total} ${projectWord}`;
  }, [total]);

  if (total <= 0) {
    return null;
  }

  return (
    <>
      <Responsive desktop>
        <UIHeading4>{`Найдено ${text}`}</UIHeading4>
      </Responsive>
      <Responsive tablet phone>
        <UIText2>{text}</UIText2>
      </Responsive>
    </>
  );
};
